var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{
  compact: _vm.compact
}},[_c('td',{staticClass:"title",attrs:{"colspan":_vm.span}},[_vm._v(_vm._s(_vm.label))]),(_vm.span == 1)?_c('td'):_vm._e(),_c('td',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }